export default "__VITE_ASSET__CFJYDD7C__"